import React from "react";
import {BASE_URL} from "../../requests/APIConfig";

function FooterLayout() {
  const year = new Date().getFullYear();
  return (
    <footer
      style={{
        background: "#fff",
        borderTop: "1px solid rgba(0, 0, 0, 0.06)",
        position: "fixed",
        left: 0,
        bottom: 0,
        width: "100%",
        zIndex: 999,
      }}
    >
      <div className="container">
        <div className="row">
          <div className="col-12 col-sm-12 col-md-12 col-lg-12">
            <div className="p-3 text-center">
              {/*<span style={{ fontSize: 14 }}>*/}
              {/*  Copyright © <b>JBTECH {year}</b> -{" "}*/}
              {/*  <a*/}
              {/*    // href="https://apistaging.jbcert.vn/"*/}
              {/*    href="http://qlvbcc.backan.edu.vn/"*/}
              {/*    target="_blank"*/}
              {/*    rel="noreferrer"*/}
              {/*  >*/}
              {/*    qlvbcc.backan.edu.vn*/}
              {/*    /!*staging.jbcert.vn*!/*/}
              {/*  </a>*/}
              {/*</span>*/}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default FooterLayout;
